// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"4d38eb99","540":"8f77a86a","957":"4d38eb99"}[chunkId] + ".chunk.css";
};